(() => {
  const desktopMedia = window.matchMedia('(min-width: 990px)');
  let frame = 0;

  const sync = () => {
    frame = 0;

    const header = document.querySelector('[data-site-header]');
    if (!header) return;

    const section = header.closest('.shopify-section');
    const currentScrollY = Math.max(0, window.scrollY);

    if (!desktopMedia.matches || currentScrollY <= 0) {
      header.removeAttribute('data-header-floating');
      section?.removeAttribute('data-header-floating');
      return;
    }

    header.setAttribute('data-header-floating', '');
    section?.setAttribute('data-header-floating', '');
  };

  const schedule = () => {
    if (frame) return;
    frame = window.requestAnimationFrame(sync);
  };

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  desktopMedia.addEventListener?.('change', schedule);
  document.addEventListener('shopify:section:load', schedule);

  sync();
})();
